import {
  companiesDataRequest,
  companiesDataSuccess,
  companiesDataFailure,
  moderatedCompaniesDataRequest,
  moderatedCompaniesDataSuccess,
  moderatedCompaniesDataFailure,
  declinedCompaniesDataRequest,
  declinedCompaniesDataSuccess,
  declinedCompaniesDataFailure,
} from '.';
import { AdminService } from '../../services/requests';

const CompaniesHelper = {
  getAllCompanies: () => async (dispatch) => {
    dispatch(companiesDataRequest());
    const companiesSavedData = JSON.parse(sessionStorage.getItem('allCompanies'));
    try {
      const response = await AdminService.getAllCompanies(1, companiesSavedData?.direction || 'desc');
      if (response) {
        dispatch(companiesDataSuccess({ data: response.data, last: response.last }));
      }
    } catch (err) {
      dispatch(companiesDataFailure(err));
    }
  },

  getModeratedCompanies: () => async (dispatch) => {
    dispatch(moderatedCompaniesDataRequest());
    const companiesSavedData = JSON.parse(sessionStorage.getItem('moderatedCompanies'));
    try {
      const response = await AdminService.getCompaniesInModerated(1, companiesSavedData?.direction || 'desc');
      if (response) {
        dispatch(moderatedCompaniesDataSuccess({ data: response.data, last: response.last }));
      }
    } catch (err) {
      dispatch(moderatedCompaniesDataFailure(err));
    }
  },

  getDeclinedCompanies: () => async (dispatch) => {
    dispatch(declinedCompaniesDataRequest());
    const companiesSavedData = JSON.parse(sessionStorage.getItem('declinedCompanies'));
    try {
      const response = await AdminService.getDeclinedCompanies(1, companiesSavedData?.direction || 'desc');
      if (response) {
        dispatch(declinedCompaniesDataSuccess({ data: response.data, last: response.last }));
      }
    } catch (err) {
      dispatch(declinedCompaniesDataFailure(err));
    }
  },
};

export default CompaniesHelper;
